// extracted by mini-css-extract-plugin
export var modalRewardStore = "ModalRewardStore_modalRewardStore__W4HCp";
export var modalContent = "ModalRewardStore_modalContent__5YcZX";
export var modalHeader = "ModalRewardStore_modalHeader__eWMD4";
export var modalBody = "ModalRewardStore_modalBody__6NFBw";
export var description = "ModalRewardStore_description__i4vUG";
export var iconWrap = "ModalRewardStore_iconWrap__4NfFv";
export var rotate = "ModalRewardStore_rotate__-lklF";
export var dotty = "ModalRewardStore_dotty__M2ncp";